import StudiesItem from "../../containers/StudiesItem/StudiesItem"
import "./StudyCard.css"
import { LogoGallery } from "../../components/LogoGallery/LogoGallery"
import uq from "../../utils/img/uq.png"
import platzi from "../../utils/img/platzi.png"
import sena from "../../utils/img/sena.png"
import unity from "../../utils/img/34.png"

const studies = [
	{
		institute: "University of Quindío",
		endDate: "2025",
		title: "Systems Engineering and Computing",
		imagePath: "utils/studies/img1",
		link: "https://wallet.xertify.co/certificates/995D2301A004?viewMode=regular",
		img: uq,
	},
	{
		institute: "University of Quindío",
		endDate: "2024",
		title: "Diploma in Information Security Management",
		imagePath: "utils/studies/img1",
		link: false,
		img: uq,
	},
	{
		institute: "Unity Learn",
		endDate: "2023",
		title: "Unity Junior Programmer",
		imagePath: "utils/studies/img1",
		link: "https://www.credly.com/badges/da39a3f4-fbed-4fe0-9156-db601be7748f",
		img: unity,
	},
	{
		institute: "Platzi",
		endDate: "2022",
		title: "Web Development and Other Technologies",
		imagePath: "utils/studies/img1",
		link: "https://platzi.com/p/B_santiago/",
		img: platzi,
	},
	{
		institute: "SENA: National Learning Service",
		endDate: "2019",
		title: "Software Programming Technician",
		imagePath: "utils/studies/img1",
		link: false,
		img: sena,
	},
]

function StudyCard() {
	return (
		<section className="card card-section">
			<div className="card-study">
				<div className="card-title">
					<h1 className="big-tittle">
						Education <br />& Certifications
					</h1>
				</div>
				<aside>
					<h2>Some of the technologies and tools I am familiar with:</h2>
					<LogoGallery />
				</aside>
				<StudiesItem studies={studies} />
			</div>
		</section>
	)
}

export { StudyCard }
